import { Pais } from './Pais';
import { Localitat } from './localitat';
import { EstudisRealitzats } from './estudiRealitzat';
import { Alumne } from './alumne';
import { Oferta } from './oferta';
import { DocumentPreinscripcio } from './documentPreinscripcio';

export class Trasllat {

    public isnew = true;
    public id: number;
    public estat: number;
    public idioma: string;
    public oferta: Oferta;
    public alumne: Alumne = new Alumne();
    public estudiRealitzat: EstudisRealitzats = new EstudisRealitzats();
    public documents: DocumentPreinscripcio[] = new Array<DocumentPreinscripcio>();
    public urlCistellaPagamentInscripcio: string;
    public haPagatInscripcio = false;
    public haPagatAcceptacio = false;
    public potModificar = true;
}



// WEBPACK FOOTER //
// ./src/app/lib/model/trasllat.ts